const css = `.LtgP1W__fillParent{width:100%;height:100%}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"fillParent":"LtgP1W__fillParent"};
